import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CodeEditorStatusBarComponent } from './code-editor-status-bar.component';

@NgModule({
  declarations: [
    CodeEditorStatusBarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatToolbarModule
  ],
  exports: [
    CodeEditorStatusBarComponent
  ]
})
export class CodeEditorStatusBarModule { }
